import { render } from "./upload_normal.vue?vue&type=template&id=1135cb7c&scoped=true"
import script from "./upload_normal.vue?vue&type=script&lang=js"
export * from "./upload_normal.vue?vue&type=script&lang=js"

import "./upload_normal.vue?vue&type=style&index=0&id=1135cb7c&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1135cb7c"]])

export default __exports__